import { DEFAULT_KNOWLEDGE_BASES_LIMIT, DEFAULT_VOICE_TRIAL_DURATION_HOURS } from '@/lib/billing/constants'
import type { PlanFormData } from './types'

export const DEFAULT_PLAN_FORM: PlanFormData = {
  name: '',
  display_name: '',
  price_monthly_cents: 0,
  expiry_days: null,
  stripe_price_id: null,
  billing_channel: 'stripe',
  shopify_plan_handle: null,
  status: 'draft',
  stripe_product_id: null,
  stripe_sync_status: null,
  stripe_sync_error: null,
  stripe_synced_at: null,
  sort_order: 0,
  initial_balance_microusd: 0,
  payment_to_balance_microusd: 0,
  payment_to_balance_count: null,
  plan_credits_expire: true,
  min_topup_cents: 500,
  topup_bonus_percent: 0,
  text_cost_multiplier: 3.0,
  text_min_charge_microusd: 10000,
  text_rounding_decimals: 2,
  voice_cost_multiplier: 3.0,
  voice_min_charge_microusd: 0,
  voice_rounding_decimals: 4,
  embedding_min_charge_microusd: 1000,
  embedding_rounding_decimals: 4,
  voice_included: false,
  voice_trial_enabled: true,
  voice_trial_duration_hours: DEFAULT_VOICE_TRIAL_DURATION_HOURS,
  voice_trial_budget_microusd: null,
  voice_concurrency_limit: 0,
  voice_agents_limit: 0,
  campaigns_enabled: true,
  campaigns_limit: 0,
  campaigns_trial_enabled: true,
  pbx_numbers_limit: 0,
  pbx_flows_limit: 0,
  knowledge_bases_limit: DEFAULT_KNOWLEDGE_BASES_LIMIT,
  knowledge_bases_size_mb_limit: null,
  users_limit: null,
  crm_integrations_limit: 0,
  shopify_stores_limit: 0,
  marketing_channels_limit: null,
  shopify_insights_trial_duration_hours: null,
  daily_spending_limit_microusd: null,
  monthly_spending_limit_microusd: null,
  grace_period_days: 1,
  benefits: [],
}
